import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { withTranslation } from 'react-i18next';
import { TiSocialFacebookCircular, TiSocialTwitterCircular, TiSocialInstagram } from 'react-icons/ti';
import lang from '../utils/translations';
import Logo from '../assets/haapaIcon.png';
import '../css/index.css';

function Footer() {
  return (
    <div className="text-white bg-gradient-0">
      <div className="container p-3">
        <div className="row">
          <div className="col-lg-6">
            <div className="d-flex align-items-start justify-content-between p-4  flex-nowrap">
              <div className="pt-4">
                <Link to="/">
                  <img src={Logo} className="ui image" style={{ width: 130 }} alt="Haapa-Logo" />
                </Link>
              </div>
              <div className="pt-4">
                <h3 className="h3 fw-bold">HAAPA Store</h3>
                <motion.p whileHover={{ scale: 1.1, color: 'var(--orange-darken)' }} className="fw-lighter fs-6 ">
                  <Link to="/"> {lang.t('Home')}</Link>
                </motion.p>

                <motion.p whileHover={{ scale: 1.1, color: 'var(--orange-darken)' }} className="fw-lighter fs-6 ">
                  <Link to="/publishers">{lang.t('Our Publishers')}</Link>
                </motion.p>

                <motion.p whileHover={{ scale: 1.1, color: 'var(--orange-darken)' }} className="fw-lighter fs-6 ">
                  <Link to="/category/contents">{lang.t('Categories')}</Link>
                </motion.p>

                <motion.p whileHover={{ scale: 1.1, color: 'var(--orange-darken)' }} className="fw-lighter fs-6 ">
                  <Link to="/animation/contents">{lang.t('Animations')}</Link>
                </motion.p>

                <motion.p whileHover={{ scale: 1.1, color: 'var(--orange-darken)' }} className="fw-lighter fs-6 ">
                  <Link to="/about-us">{lang.t('About Us')}</Link>
                </motion.p>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="d-flex align-items-start justify-content-around p-4 flex-nowrap">
              <div className="pt-4">
                <h3 className=" h3 fw-bold">{lang.t('Support')}</h3>
                <motion.p whileHover={{ scale: 1.1, color: 'var(--orange-darken)' }} className="fw-lighter fs-6 ">
                  <Link to="/help">{lang.t('Help')}</Link>
                </motion.p>
                <motion.p whileHover={{ scale: 1.1, color: 'var(--orange-darken)' }} className="fw-lighter fs-6 ">
                  <Link to="/faq">FAQ</Link>
                </motion.p>
                <motion.p whileHover={{ scale: 1.1, color: 'var(--orange-darken)' }} className="fw-lighter fs-6 ">
                  <Link to="/contact-us"> {lang.t('Contact Us')}</Link>
                </motion.p>
              </div>
              <div className="pt-4">
                <h3 className=" h3 fw-bold">{lang.t('Connect')}</h3>
                <motion.p whileHover={{ scale: 1.1, color: 'var(--orange-darken)' }} className="fw-lighter fs-6 ">
                  <a href="https://www.facebook.com/haapastore" target="_blank" rel="noopener noreferrer">
                    <TiSocialFacebookCircular size={30} /> Facebook
                  </a>
                </motion.p>
                <motion.p whileHover={{ scale: 1.1, color: 'var(--orange-darken)' }} className="fw-lighter fs-6 ">
                  <a href="https://www.twitter.com/haapastore" target="_blank" rel="noopener noreferrer">
                    <TiSocialTwitterCircular size={30} />
                    Twitter &nbsp;&nbsp; &nbsp;&nbsp;
                  </a>
                </motion.p>
                <motion.p whileHover={{ scale: 1.1, color: 'var(--orange-darken)' }} className="fw-lighter fs-6 ">
                  <a href="https://www.instagram.com/haapastore?r=nametag" target="_blank" rel="noopener noreferrer">
                    <TiSocialInstagram size={30} /> Instagram
                  </a>
                </motion.p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default withTranslation()(Footer);
